import Feature from 'components/framework/models/Feature';
import Epic from 'components/framework/models/Epic';
import Requirement from 'components/framework/models/Requirement';
import Initiative from 'components/framework/models/Initiative';
import Release from 'components/framework/models/Release';

export function promotedRecordQuery() {
  return Epic.select(['id', 'referenceNum', 'name'])
    .merge({ workflowStatus: ['name', 'color'] })
    .union(
      Feature.select(['id', 'referenceNum', 'name']).merge({
        workflowStatus: ['name', 'color'],
      })
    )
    .union(
      Requirement.select(['id', 'referenceNum', 'name']).merge({
        workflowStatus: ['name', 'color'],
      })
    )
    .union(
      Initiative.select(['id', 'referenceNum', 'name']).merge({
        workflowStatus: ['name', 'color'],
      })
    )
    .union(
      Release.select(['id', 'referenceNum', 'name']).merge({
        workflowStatus: ['name', 'color'],
      })
    );
}
